import {AsyncAuthorization, AsyncStatus} from '@yandex-taxi/react-integration-api'
import {MapContext} from '@yandex-taxi/react-ymaps'
import React, {MutableRefObject, useEffect, useState} from 'react'

import {useLoaderContext} from './Context'

type Props = {
  state: Partial<ymaps.IMapConstructorState>
  options?: Partial<ymaps.IMapConstructorOptions>
  component?: any
  rootRef?: MutableRefObject<HTMLElement | null>
  fallback?: (state: AsyncAuthorization) => React.ReactElement
}

// провайдер из пакета не подошел, потому что нужно было набросить стили, а там это коряво сделано
// надо бы там поправить этот момент
const Map: React.FC<React.PropsWithChildren<Props>> = props => {
  const {children, state, options, fallback} = props
  const ref = props.rootRef
  const asyncState = useLoaderContext()
  const {status} = asyncState
  const [map, setMap] = useState<ymaps.Map>()

  useEffect(() => {
    if (status === AsyncStatus.SUCCESS && ref && ref.current instanceof HTMLElement) {
      setMap(new ymaps.Map(ref.current, state, options))
    }
  }, [options, ref, state, status])

  if (map) {
    return <MapContext.Provider children={children} value={map} />
  }

  if (fallback) {
    return fallback(asyncState)
  }

  return null
}

export default Map
